import { v4 as uuidv4 } from 'uuid'
import jwt from 'jsonwebtoken'
import jwtDecode from 'jwt-decode'

export default   {
    isAuthenticated() {
        const token = localStorage.getItem('paperChatToken')
        if (token) {
            return true
        } else {
            return false
        }
    },


    join(roomName, password, userName){
        var userUUID = uuidv4()
        var user = {
            userUID: userUUID,
            name: userName,
            roomName: roomName
        }

       // console.log(user)
        var token = jwt.sign(user, 'paperchatultramaxpro')

       // console.log(token)
        localStorage.setItem("paperChatToken", JSON.stringify(token))

        return {
            userUID : userUUID,
            name: userName,
        }
    },


    disconnect() {
      localStorage.removeItem("paperChatToken")
    },

    getCurrentUser() { 
      return jwtDecode(localStorage.getItem('paperChatToken'))
    },
  }